import React, { useEffect } from 'react';
import showErrorToast from 'mini-toast/lib/utils/showErrorToast';
import type { ErrorToastProps } from '../schema/ErrorToast.types';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { hardRefresh } from '../utils/hardRefresh';

/**
 * Functional Component to display the Error toast
 * @param props Error Screen Props
 */
export const ErrorToast = (props: ErrorToastProps): JSX.Element => {
    const strings = getOwaMiniCommonStrings();
    const { actionButton, onTimeout, title, showDefaultActionButton = true } = props;

    const showActionButton = !!actionButton?.onClick || showDefaultActionButton;

    const onClickRetry = () => {
        (actionButton?.onClick || hardRefresh)();
    };

    useEffect(() => {
        showErrorToast({
            label: title ?? strings.networkErrorToastTitle,
            primaryButtonLabel: showActionButton && strings.retryButtonAllCaps,
            onPrimaryButtonClick: showActionButton && onClickRetry,
            onTimeout,
        });
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook useEffect has missing dependencies: 'onClickRetry', 'onTimeout', 'showActionButton', 'strings.networkErrorToastTitle', and 'strings.retryButtonAllCaps'. Either include them or remove the dependency array. */
    }, [props, title]);

    return <></>;
};
